
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkProjectShareDossierEntryDto } from '../models/work-project-share-dossier-entry-dto';

export function getUpdateProjectShareDtoFormGroup() {
return new FormGroup({
    title: new FormControl<string | undefined>('', [Validators.maxLength(200)]),
    validFrom: new FormControl<string | undefined>(''),
    validUntil: new FormControl<string | undefined>(''),
    dossierSelection: new FormControl<WorkProjectShareDossierEntryDto[]>([]),
    excludedTaskIds: new FormControl<Array<number> | undefined>([]),
    includedTaskIds: new FormControl<Array<number> | undefined>([]),
    contactIds: new FormControl<Array<number> | undefined>([]),
    active: new FormControl<boolean | undefined>(undefined),
})
;
}
      